<template>
  <integration-call-rail v-if="pageName === integrationEnum.CallRail.url"/>
  <integration-partner-call-rail v-else-if="pageName === integrationEnum.PartnerCallRail.url"/>
  <integration-google-calendar v-else-if="pageName === integrationEnum.GoogleCalendar.url"/>
  <integration-launch-control v-else-if="pageName === integrationEnum.LaunchControl.url"/>
  <integration-smrt-phone v-else-if="pageName === integrationEnum.SmrtPhone.url"/>

  <div v-else class="integrations">

    <integration-box
      class="integration"
      heading="smrtPhone"
      type="Phone System"
      :upgrade-required="!hasSmrtPhoneFeature"
      :integration="integrationEnum.SmrtPhone"
      :is-integrated="hasSmrtPhoneIntegration"
    >
      <p class="integration--description">smrtPhone is an all-in-one communication platform for sales-driven businesses.
        Voice, text, power dialing, lead management - all effortlessly synced to your CRM system.</p>

      <p class="integration--description">Don't have smrtPhone?
        <a href="https://www.smrtphone.io/forefront" target="_blank">Sign
        up for smrtPhone</a>
      </p>
    </integration-box>

    <integration-box
      class="integration"
      heading="CallRail"
      type="Phone System"
      :upgrade-required="!hasPhoneFeature"
      :integration="integrationEnum.CallRail"
      :is-integrated="hasCallRailIntegration"
    >
      <p class="integration--description">CallRail helps you track phone calls and web forms and gives you analytics
        that help you optimize your marketing and increase ROI on your PPC, SEO, and offline ad campaigns.</p>

      <p class="integration--description">Don't have CallRail? <a href="https://www.callrail.com/" target="_blank">Sign
        up for CallRail</a></p>
    </integration-box>

    <integration-box
      class="integration"
      heading="Launch Control"
      type="Texting Platform"
      :integration="integrationEnum.LaunchControl"
      :is-integrated="hasLaunchControlIntegration"
    >
      <p class="integration--description">Launch Control is text messaging for real estate professionals, and now it
        integrates with Forefront. Use
        Launch Control to manage your prospects and when they become leads push them directly into Forefront so you can
        close the deal.</p>

      <p class="integration--description">Don't have Launch Control? <a href="https://launchcontrol.us/?ref=don65"
                                                                        target="_blank">Sign
        up for Launch Control</a></p>
    </integration-box>

    <integration-box
      class="integration"
      heading="Google Calendar"
      type="Calendar"
      :upgrade-required="!hasCalendarFeature"
      :integration="integrationEnum.GoogleCalendar"
      :is-integrated="hasGoogleCalendarIntegration"
    >
      <p class="integration--description">Google Calendar allows you to spend less time planning and more time doing
        with a shareable calendar.</p>

      <p class="integration--description"><strong>NOTE:</strong> You can only integrate one calendar with Forefront CRM.
      </p>

      <p class="integration--description">Don't have Google Calendar? <a href="https://www.google.com/calendar"
                                                                         target="_blank">Sign
        up for Google Calendar</a></p>
    </integration-box>

    <integration-box
      v-if="hasPartnerCallRailIntegration"
      class="integration"
      heading="CallRail"
      type="Phone System"
      :integration="integrationEnum.PartnerCallRail"
      :is-integrated="true"
    >
        <p class="integration--description">CallRail helps you track phone calls and web forms and gives you analytics
            that help you optimize your marketing and increase ROI on your PPC, SEO, and offline ad campaigns.</p>
    </integration-box>
  </div>
</template>

<script>
import IntegrationBox from "./components/IntegrationBox";
import IntegrationCallRail from "./integrations/IntegrationCallRail.vue";
import IntegrationLaunchControl from "./integrations/IntegrationLaunchControl.vue";
import IntegrationGoogleCalendar from "./integrations/IntegrationGoogleCalendar.vue";
import IntegrationSmrtPhone from "./integrations/IntegrationSmrtPhone.vue";
import IntegrationPartnerCallRail from "./integrations/IntegrationPartnerCallRail.vue";
import AppUpgradeRequired from "../../components/app/AppUpgradeRequired.vue";

export default {
  name: "IntegrationsTab",
  components: {
    IntegrationPartnerCallRail,
    AppUpgradeRequired,
    IntegrationSmrtPhone,
    IntegrationGoogleCalendar,
    IntegrationLaunchControl,
    IntegrationCallRail,
    IntegrationBox
  },
  data() {
    return {
      integrationEnum: {
        "CallRail": {
          "url": "callrail",
          "label": "CallRail",
          "iconPath": "/images/callrail-icon.png",
        },
        "PartnerCallRail": {
          "url": "partner-callrail",
          "label": "Partner CallRail",
          "iconPath": "/images/callrail-icon.png",
        },
        "GoogleCalendar": {
          "url": "google-calendar",
          "label": "Google Calendar",
          "iconPath": "/images/google-calendar-icon.png",
        },
        "LaunchControl": {
          "url": "launch-control",
          "label": "Launch Control",
          "iconPath": "/images/launch-control-icon.png",
        },
        "SmrtPhone": {
          "url": "smrtphone",
          "label": "SmrtPhone",
          "iconPath": "/images/smrtphone-icon.png",
        },
      }
    }
  },
  computed: {
    integrations() {
      return this.$store.getters.integrations;
    },
    pageName() {
      return this.$route.params.page;
    },
    hasPhoneFeature() {
      return this.$store.state.accounts.features.PhoneIntegration;
    },
    hasSmrtPhoneFeature() {
      return this.$store.state.accounts.features.SmrtPhoneIntegration;
    },
    hasCalendarFeature() {
      return this.$store.state.accounts.features.CalendarIntegration;
    },
    hasSmrtPhoneIntegration() {
      return this.$store.getters.isSmrtPhoneIntegrationComplete;
    },
    hasLaunchControlIntegration() {
      return !!this.$store.getters.hasLaunchControlIntegration;
    },
    hasCallRailIntegration() {
      return !!this.$store.getters.hasCallRailIntegration;
    },
    hasGoogleCalendarIntegration() {
      return !!this.$store.getters.hasGoogleCalendarIntegration;
    },
    partnerCallRailIntegration() {
      return this.$store.getters.partnerCallRailIntegration;
    },
    hasPartnerCallRailIntegration() {
      return !!this.partnerCallRailIntegration;
    },
    partnerPortalIntegrationHeading() {
      return 'llllllllllllllllll';
    },
  },
};
</script>

<style lang="scss" scoped>

.integrations {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 0;
}

.integration {
  width: 46%;
  margin: 10px 2%;
}

.integration--description {

  &:not(:last-of-type) {
    margin-bottom: 1rem;
  }
}
</style>
